module.exports = __webpack_public_path__ + "static/img/1-1.4d30cd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/1-1.png
// module id = I4Pk
// module chunks = 0